module.exports = __webpack_public_path__ + "static/20-01705e16dbb1f0ef922f93be33ae05dd.jpg";